import { memo } from 'react';

import ArrowIconSVG from '@/assets/arrow-right-icon.svg?react';
import { merge } from '@/components';
import { Icon, IconProps } from '@/components/core';

export type ArrowIconProps = Omit<IconProps, 'SVGComponent'> & {
  rotation: 'up' | 'right' | 'down' | 'left';
};

const IArrowIcon = ({ rotation, className, ...rest }: ArrowIconProps) => {
  /* prettier-ignore */
  const rotationStyles = [
    rotation === 'up' && 'rotate-270',
    rotation === 'right' && 'rotate-0',
    rotation === 'down' && 'rotate-90',
    rotation === 'left' && 'rotate-180',
  ];

  return <Icon SVGComponent={ArrowIconSVG} className={merge(rotationStyles, className)} {...rest} />;
};

export const ArrowIcon = memo(IArrowIcon) as typeof IArrowIcon;
